<div class="flex items-center space-x-2">
  <p-avatarGroup>
    @for (user of users(); track $index) {
      <p-avatar
        [label]="!user.avatarUrl ? getInitial(user.fullName) : ''"
        [image]="user.avatarUrl"
        shape="circle"
        size="large"
        class="border-2 border-white shadow-md"
        [pTooltip]="user.fullName"
        tooltipPosition="top"
        [tooltipStyleClass]="'font-medium'"
        [attr.data-testid]="'user-avatar-' + $index"
      ></p-avatar>
    }
    <p-avatar
      *appProjectRoleAccess="projectManagementConfig()"
      (click)="navigateToUserManagement()"
      (keydown.enter)="navigateToUserManagement()"
      (keydown.space)="navigateToUserManagement()"
      data-testid="add-user-avatar"
      icon="pi pi-plus"
      shape="circle"
      size="large"
      class="border-2 border-white shadow-xs cursor-pointer bg-blue-500 text-white"
      tabindex="0"
      [attr.aria-label]="'Add user'"
    ></p-avatar>
  </p-avatarGroup>
</div>
